import PlanBadge from '../components/PlanBadge';

export default function Introduction() {
  return (
    <section id="introduction" className="mb-16">
      <h2 className="text-3xl font-bold text-gray-900 mb-4">API Reference</h2>
      <p className="text-lg text-gray-700 leading-relaxed mb-4">
        The Snaptura provides a simple REST API for capturing high-quality website screenshots
        and generating PDFs with extensive customization options.
      </p>
      <p className="text-gray-700 mb-6">
        All API requests require authentication using your API key. The base URL for all
        requests is <code className="bg-gray-100 px-2 py-1 rounded text-sm">https://api.snaptura.online</code>
      </p>

      <div className="bg-orange-50 border-l-4 border-orange-400 p-4 mb-6">
        <p className="text-sm text-orange-800">
          <strong>📧 Email Verification:</strong> New accounts start with 10 free API requests.
          After using these requests, you must verify your email address to continue using the API.
          Check your inbox for the verification email or request a new one from your dashboard.
        </p>
      </div>

      {/* Feature Availability Table */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mt-8">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Feature Availability by Plan</h3>
        <div className="overflow-x-auto">
          <table className="min-w-full">
            <thead>
              <tr className="border-b border-blue-200">
                <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">Feature</th>
                <th className="px-4 py-2 text-center text-sm font-semibold text-gray-700">Minimum Plan</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-blue-100">
              <tr>
                <td className="px-4 py-3 text-sm text-gray-700">Basic Screenshots (PNG, JPEG)</td>
                <td className="px-4 py-3 text-center"><PlanBadge plan="free" size="sm" /></td>
              </tr>
              <tr>
                <td className="px-4 py-3 text-sm text-gray-700">WebP Format</td>
                <td className="px-4 py-3 text-center"><PlanBadge plan="starter" size="sm" /></td>
              </tr>
              <tr>
                <td className="px-4 py-3 text-sm text-gray-700">Full-Page Screenshots</td>
                <td className="px-4 py-3 text-center"><PlanBadge plan="starter" size="sm" /></td>
              </tr>
              <tr>
                <td className="px-4 py-3 text-sm text-gray-700">PDF Generation</td>
                <td className="px-4 py-3 text-center"><PlanBadge plan="starter" size="sm" /></td>
              </tr>
              <tr>
                <td className="px-4 py-3 text-sm text-gray-700">Device Emulation</td>
                <td className="px-4 py-3 text-center"><PlanBadge plan="starter" size="sm" /></td>
              </tr>
              <tr>
                <td className="px-4 py-3 text-sm text-gray-700">Custom CSS/JS Injection</td>
                <td className="px-4 py-3 text-center"><PlanBadge plan="growth" size="sm" /></td>
              </tr>
              <tr>
                <td className="px-4 py-3 text-sm text-gray-700">Hide Elements</td>
                <td className="px-4 py-3 text-center"><PlanBadge plan="growth" size="sm" /></td>
              </tr>
              <tr>
                <td className="px-4 py-3 text-sm text-gray-700">Block Ads & Cookie Banners</td>
                <td className="px-4 py-3 text-center"><PlanBadge plan="growth" size="sm" /></td>
              </tr>
              <tr>
                <td className="px-4 py-3 text-sm text-gray-700">Batch Processing (up to 10 URLs)</td>
                <td className="px-4 py-3 text-center"><PlanBadge plan="pro" size="sm" /></td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="text-xs text-gray-600 mt-4">
          📘 Each plan includes all features from lower tiers. See <a href="/pricing" className="text-blue-600 hover:text-blue-700 font-medium">pricing page</a> for quota limits.
        </p>
      </div>
    </section>
  );
}